<form [formGroup]="form">
  <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
    <mat-label>{{ T_SCOPE + '.labels.dashboard-name' | translate }}</mat-label>
    <input matInput formControlName="title" required />
  </mat-form-field>
</form>
